import {
  bulkShortlistUpdateFn,
  createCustomFieldFn,
  createShortlistFn,
  deleteShortlistFn,
  downloadShortlistFn,
  editCustomFieldFn,
  fetchCompanyParticipants,
  fetchProspectsByFilters,
  fetchShortlistPageData,
  fetchSortableFields,
  fetchUserShortlistsFn,
  fetchUserTags,
  getDownloadShortlisStatustFn,
  moveProfileBetweenShortlistsFn,
  submitImportProspects,
  undoAddProfilesToShortlists,
  updateCategoriesConfigFn,
  updateShortlistById,
  updateShortlistProfileByIdFn,
  updateShortlistProfileByQuery,
  updateShortlistProfiles,
} from './shortlist'

const shortlistApi = {
  getShortlists: {
    key: 'FETCH_USER_SHORTLISTS',
    fn: fetchUserShortlistsFn,
  },
  createShortlist: {
    key: 'CREATE_USER_SHORTLISTS',
    fn: createShortlistFn,
  },
  deleteShortlist: {
    key: 'DELETE_USER_SHORTLISTS',
    fn: deleteShortlistFn,
  },
  updateShortlistProfiles: {
    key: 'UPDATE_SHORTLIST_PROFILES',
    fn: updateShortlistProfiles,
  },
  updateShortlistProfileById: {
    key: 'SINGLE_SHORTLIST_UPDATE',
    fn: updateShortlistProfileByIdFn,
  },
  bulkShortlistUpdate: {
    key: 'BULK_SHORTLIST_UPDATE',
    fn: bulkShortlistUpdateFn,
  },
  getShortlistPageData: {
    key: 'FETCH_SHORTLIST_PAGE_DATA',
    fn: fetchShortlistPageData,
  },
  updateCategoriesConfig: {
    key: 'PUT_CATEGORIES_CONFIG',
    fn: updateCategoriesConfigFn,
  },
  moveProfileBetweenShortlists: {
    key: 'MOVE_PROFILE_BETWEEN_SHORTLIST',
    fn: moveProfileBetweenShortlistsFn,
  },
  getUserTags: {
    key: 'FETCH_USER_TAGS',
    fn: fetchUserTags,
  },
  getCompanyParticipants: {
    key: 'FETCH_COMPANY_PARTICIPANTS',
    fn: fetchCompanyParticipants,
  },
  getProspectsByFilters: {
    key: 'FETCH_PROSPECTS_BY_FILTERS',
    fn: fetchProspectsByFilters,
  },
  submitImportingProspects: {
    key: 'POST_IMPORTING_PROSPECTS',
    fn: submitImportProspects,
  },
  getSortableFields: {
    key: 'FETCH_SORTABLE_FIELDS',
    fn: fetchSortableFields,
  },
  downloadShortlist: {
    key: 'DOWNLOAD_SHORTLIST',
    fn: downloadShortlistFn,
  },
  getDownloadShortlistStatus: {
    key: 'FETCH_DOWNLOAD_SHORTLIST_STATUS',
    fn: getDownloadShortlisStatustFn,
  },
  createShortlistCustomColumn: {
    key: 'POST_SHORTLIST_CUSTOM_COLUMNS',
    fn: createCustomFieldFn,
  },
  editShortlistCustomColumn: {
    key: 'PUT_SHORTLIST_CUSTOM_COLUMNS',
    fn: editCustomFieldFn,
  },
  updateShortlistProfileByQuery: {
    key: 'UPDATE_SHORTLIST_PROFILIES_BY_QUERY',
    fn: updateShortlistProfileByQuery,
  },
  updateShortlistById: {
    key: 'UPDATE_SHORTLIST_BY_ID',
    fn: updateShortlistById,
  },
  undoAddProfilesToShortlists: {
    key: 'UNDO_ADD_PROFILES_TO_SHORTLISTS',
    fn: undoAddProfilesToShortlists,
  },
}

export default shortlistApi
